import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelRadio as _vModelRadio, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "l-modal__bg"
}
const _hoisted_2 = { class: "bank" }
const _hoisted_3 = { class: "loading" }
const _hoisted_4 = { style: {"padding-bottom":"500px"} }
const _hoisted_5 = { style: {"padding-top":"40px"} }
const _hoisted_6 = { class: "radio-button-area" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { style: {"padding-top":"40px"} }
const _hoisted_10 = { class: "text-area" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { style: {"padding-top":"40px"} }
const _hoisted_13 = { class: "radio-button-area" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { style: {"padding-top":"40px"} }
const _hoisted_17 = { class: "text-area" }
const _hoisted_18 = { class: "error" }
const _hoisted_19 = { style: {"padding-top":"40px"} }
const _hoisted_20 = { class: "text-area" }
const _hoisted_21 = { class: "error" }
const _hoisted_22 = { style: {"padding-top":"40px"} }
const _hoisted_23 = { class: "text-area" }
const _hoisted_24 = { class: "error" }
const _hoisted_25 = { class: "button-area" }

import { onMounted, ref } from "vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { useRouter } from "vue-router";
import { Field, Form, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";

import * as yup from "yup";
import { bankInfoRequest } from "../types/apiRequest";

export default /*@__PURE__*/_defineComponent({
  __name: 'Bank',
  setup(__props) {

const bank = ref("");
const bankAccountType = ref(0);
const accountType = ref(0)
const router = useRouter();
const branch = ref("");
const bankAccountNumber = ref("");
const bankAccountName = ref("");
const updated = ref(false);

const userInfoStore = UserInfoStore();
const loading = ref(false);
const deleting = ref(false);
const validationSchema = ref(
  yup.object().shape({
    bank: yup
      .string()
      .trim()
      .required("銀行名は必須です")
      .min(1)
      .label("銀行名"),
    branch: yup
      .string()
      .trim()
      .required("支店名は必須です")
      .min(1)
      .label("支店名"),
    bankAccountNumber: yup
      .string()
      .required("口座番号は必須です")
      .length(7, "口座番号は半角数字7桁で入力してください")
      .matches(/^[0-9]+$/, "口座番号は半角数字7桁で入力してください")
      .label("口座番号"),
    bankAccountName: yup
      .string()
      .required("口座名義は必須です")
      .matches(/^[ｦ-ﾟ ァ-ヶー （） a-zA-Z \s]*$/, "口座名義はカタカナ、アルファベットで入力してください")
      .label("口座名義"),
  })
);
onMounted(async () => {
  if (!userInfoStore.bankInfo.id) {
    await userInfoStore.getBankInfo();
    if (!userInfoStore.bankInfo.id) {
      document.title = "振込先口座情報登録";
      return;
    }
  }
  // 登録済の情報を初期値で入れる
  setInitialData();
});

const setInitialData = () => {
  document.title = "振込先口座情報更新";
  bank.value = userInfoStore.bankInfo.bank_name;
  bankAccountType.value = userInfoStore.bankInfo.bank_type;
  accountType.value = userInfoStore.bankInfo.account_type;
  branch.value = userInfoStore.bankInfo.bank_branch;
  bankAccountNumber.value = userInfoStore.bankInfo.bank_code;
  bankAccountName.value = userInfoStore.bankInfo.bank_account_name;
};

// 登録処理
const onSubmit = async () => {
  // 複数回リクエストが飛ばないようにする
  if (loading.value) return;
  loading.value = true;
  const request: bankInfoRequest = {
    bank_account_name: bankAccountName.value, //口座名義
    bank_branch: branch.value, //支店名
    bank_code: bankAccountNumber.value || "", //口座番号
    bank_name: bank.value, //銀行名
    bank_type: bankAccountType.value, //口座種別 普通:0, 当座: 1
    account_type: accountType.value // 種別 個人:0, 法人: 1
  };

  await userInfoStore.updateBankInfo(request).then((v) => {
    if (v) {
      updated.value = true;
      if (userInfoStore.isRegistFromProjectDetail.show) {
        if (!userInfoStore.userSnsInfo.length || !userInfoStore.userSnsInfo.find((v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType)) {
          router.replace("/sns-accounts");
        } else if (userInfoStore.addressInfo.id < 0) {
          router.replace("/address");
        } else {
          userInfoStore.setIsRegistFromProjectDetail({ show: false, title: "", mediaType: -1 });
          router.replace("/project-detail");
        }
      } else {
        router.go(-1);
      }
    }
    loading.value = false;
  });
};
async function deleteBanckAccount() {
  deleting.value = true;
  await userInfoStore.deleteBankInfo().then((v) => {
    if (v) {
      updated.value = true;
      setTimeout(() => router.go(-2), 1000);
    }

    deleting.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, _cache[9] || (_cache[9] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
      ]), 512 /* NEED_PATCH */), [
        [_vShow, loading.value]
      ]),
      _createCommentVNode(" <header class=\"header\">\n      <img src=\"../assets/omi-logo.svg\" />\n    </header> "),
      _createCommentVNode(" <div class=\"title\">\n        <p v-if=\"!isUser\">事前登録受付</p>\n        <p v-else>ユーザー情報更新</p>\n      </div> "),
      (!updated.value)
        ? (_openBlock(), _createBlock(_unref(Form), {
            key: 0,
            class: "form",
            validationSchema: validationSchema.value
          }, {
            default: _withCtx(({ meta: { valid } }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", null, "種別", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "0",
                      name: "accountType",
                      value: "0",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountType).value = $event)),
                      disabled: loading.value || deleting.value
                    }, null, 8 /* PROPS */, _hoisted_7), [
                      [_vModelRadio, accountType.value]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", { for: "0" }, "個人", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "1",
                      name: "accountType",
                      value: "1",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountType).value = $event)),
                      disabled: loading.value || deleting.value
                    }, null, 8 /* PROPS */, _hoisted_8), [
                      [_vModelRadio, accountType.value]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("label", { for: "1" }, "法人", -1 /* HOISTED */)),
                    _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1 /* HOISTED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", null, "銀行名", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: bank.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((bank).value = $event)),
                      name: "bank",
                      placeholder: "〇〇銀行",
                      class: "text-field",
                      disabled: loading.value || deleting.value,
                      tabindex: "1"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ErrorMessage), { name: "bank" }, {
                        default: _withCtx(({ message }) => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(message), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", null, "口座種別", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "0",
                      name: "bankAccountType",
                      value: "0",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bankAccountType).value = $event)),
                      disabled: loading.value || deleting.value
                    }, null, 8 /* PROPS */, _hoisted_14), [
                      [_vModelRadio, bankAccountType.value]
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("label", { for: "0" }, "普通", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "1",
                      name: "bankAccountType",
                      value: "1",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((bankAccountType).value = $event)),
                      disabled: loading.value || deleting.value
                    }, null, 8 /* PROPS */, _hoisted_15), [
                      [_vModelRadio, bankAccountType.value]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "1" }, "当座", -1 /* HOISTED */)),
                    _cache[17] || (_cache[17] = _createElementVNode("div", null, null, -1 /* HOISTED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", null, "支店名", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: branch.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((branch).value = $event)),
                      name: "branch",
                      placeholder: "支店名",
                      class: "text-field",
                      disabled: loading.value || deleting.value,
                      tabindex: "3"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ErrorMessage), { name: "branch" }, {
                        default: _withCtx(({ message }) => [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(message), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", null, "口座番号", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      inputmode: "numeric",
                      modelValue: bankAccountNumber.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((bankAccountNumber).value = $event)),
                      name: "bankAccountNumber",
                      placeholder: "1234567",
                      class: "text-field",
                      disabled: loading.value || deleting.value,
                      tabindex: "4"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createElementVNode("div", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("p", { style: {"font-size":"12px","color":"#2c3e50"} }, " ※口座番号が7桁に満たない場合は口座番号の前に「0」を加えて入力してください ", -1 /* HOISTED */)),
                      _createVNode(_unref(ErrorMessage), { name: "bankAccountNumber" }, {
                        default: _withCtx(({ message }) => [
                          _createElementVNode("p", _hoisted_21, _toDisplayString(message), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", null, "口座名義", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: bankAccountName.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bankAccountName).value = $event)),
                      name: "bankAccountName",
                      placeholder: "ヤマダ タロウ",
                      class: "text-field",
                      disabled: loading.value || deleting.value,
                      tabindex: "5"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ErrorMessage), { name: "bankAccountName" }, {
                        default: _withCtx(({ message }) => [
                          _createElementVNode("p", _hoisted_24, _toDisplayString(message), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                (!_unref(userInfoStore).bankInfo.id)
                  ? (_openBlock(), _createBlock(CommonButton, {
                      key: 0,
                      data: {
            status: !valid || loading.value ? 2 : 0,
            button: deleting.value ? `登録中` : _unref(userInfoStore).isRegistFromProjectDetail.show && !_unref(userInfoStore).userSnsInfo.find((v) => v.media_type == _unref(userInfoStore).isRegistFromProjectDetail.mediaType) ? `次へ` : `登録`,
          },
                      onClick: ($event: any) => (valid && !loading.value && !deleting.value ? onSubmit() : '')
                    }, null, 8 /* PROPS */, ["data", "onClick"]))
                  : (_openBlock(), _createBlock(CommonButton, {
                      key: 1,
                      data: {
            status: !valid || loading.value ? 2 : 0,
            button: loading.value ? `更新中` : `更新`,
          },
                      onClick: ($event: any) => (valid && !loading.value && !deleting.value ? onSubmit() : ''),
                      disabled: !valid || loading.value,
                      style: {"margin-bottom":"20px"}
                    }, null, 8 /* PROPS */, ["data", "onClick", "disabled"])),
                (_unref(userInfoStore).bankInfo.bank_account_name)
                  ? (_openBlock(), _createBlock(CommonButton, {
                      key: 2,
                      data: {
            status: 3,
            button: deleting.value ? `削除中` : `削除`,
          },
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (!loading.value && !deleting.value ? deleteBanckAccount() : ''))
                    }, null, 8 /* PROPS */, ["data"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["validationSchema"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})